import React from "react";

import { PublicTemplate } from "~/public/Template";

import CompanyLogos from "./CompanyLogos";
import TestimonialPane from "./TestimonialPane";

import styles from "../css/Auth.module.css";

export default function TemplateWithContentPane() {
	const { template } = window.INITIAL_STATE;
	if (!template) return <TestimonialPane />;

	const { title, global_key: globalKey } = template;
	if (!globalKey) return <TestimonialPane />;
	return (
		<div className={styles.authPane}>
			<div className={styles.templatePane}>
				<div className={styles.shiftedUp}>
					<h2>
						<span className={styles.emphasis}>“{title}”</span>
					</h2>
				</div>
				<div className={styles.shiftedCenter}>
					<div className={styles.templatePreviewContainer}>
						<div>
							<div className={styles.templatePreview}>
								<PublicTemplate templateGlobalKey={globalKey} usingLocalState />
							</div>
						</div>
					</div>
				</div>

				<CompanyLogos />
			</div>
		</div>
	);
}
